/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/AppointmentRegistrationSections/AppointmentInformation/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import React from "react";
import styles from "./AppointmentInformation.module.css";
import { useTranslation } from "react-i18next";
import AssetImage from "../../AssetImage";

const AppointmentInformation = ({ requirement, category }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.sectionContent}>
      <div className={styles.requirementInfo}>
        <div className={styles.technicalDetailContainer}>
          <label className={styles.labelText}>
            {t("components.appointmentRegistrationModal.technicalDetail")}
          </label>
          <span className={styles.requirementText}>
            {requirement?.detalleTecnico || "-"}
          </span>
        </div>
        <div className={styles.categoriesContainer}>
          <div className={styles.categoryContainer}>
            <label className={styles.labelText}>
              {t("components.appointmentRegistrationModal.category")}
            </label>
            <span className={styles.requirementText}>
              {category?.nombre || "-"}
            </span>
          </div>
          <div className={styles.subcategoryContainer}>
            <label className={styles.labelText}>
              {t("components.appointmentRegistrationModal.subcategory")}
            </label>
            <span className={styles.requirementText}>
              {requirement?.nombreSubcategoria || "-"}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.technicalExampleContainer}>
        <label className={styles.labelText}>
          {t("components.appointmentRegistrationModal.technicalExample")}
        </label>
        {requirement?.ejemploTecnico && (
          <AssetImage
            src={requirement.ejemploTecnico}
            alt={t("common.technicalExampleAlt", {
              name: requirement?.nombre || t("common.notAvailable"),
            })}
            className={styles.technicalExampleImage}
          />
        )}
        
      </div>
    </div>
  );
};

export default AppointmentInformation;